<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">新增保障群組</h3>
                </div>
                <div class="modal-body">
                    <form class="form">
                       <div class="row">
                           <!-- 十大保障大類 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right" for="big-ten">十大保障大類</label>
                                    <div class="col-9">
                                        <select class="form-control form-control-inline form-large" v-model="bigCode">
                                            <option value="">請選擇</option>
                                            <option                         
                                             v-for="(item, index) in bigCategory"
                                             :key="index"
                                             :value="item.codeCategory">
                                                {{ item.name }}
                                            </option>
                                        </select>                                       
                                    </div>
                                </div>
                            </div>
                            <!-- 保障中分類代碼 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right" for="mid-code">保障中分類代碼</label>
                                    <div class="col-9">
                                        <input class="form-control form-control-inline" type="text" maxlength="4" disabled="true" v-model="midCode"/>                                    
                                    </div>
                                </div>
                            </div>
                            <!-- 保障中分類名稱 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right" for="mid-name">保障中分類名稱</label>
                                    <div class="col-9">
                                        <input class="form-control form-control-inline" type="text" maxlength="20" v-model="midName"/>
                                    </div>
                                </div>
                            </div>
                            <!-- 備註 -->
                            <!-- <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right" for="mid-name">備註</label>
                                    <div class="col-9">
                                        <input class="form-control form-control-inline" type="text" maxlength="50" v-model="memo"/>
                                    </div>
                                </div>
                            </div> -->
                       </div> 
                    </form>
                </div>
                <div class="modal-footer">
                    <a @click="doClose()" class="btn btn-default editbtn mr-3">取消</a>
                    <a @click="doInsert()" class="btn btn-primary editbtn">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ThisMixin from "../util/CoverageCategory.js";
import { queryMidCategoryMaxNum, insertMidCategory } from "@/service";

export default {
  name: "CoverageCategoryGroupAddModal",
  mixins: [ThisMixin],
  data() {
    return {
      bigCode: "",
      midCode: "",
      midName: "",
      memo: "",
      reqData: {
        code_category: "",
        code: "",
        code_name: "",
        modification_type: "I",
        modification_reason: "新增保障群組",
        memo: "",
        status: "0",
        creator: "",
        creatorname: "",
      },
      userID: "",
      userName: "",
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    //當AddModal被打開時執行initData方法
    open: "initData",
    //當十大類保障切換時執行changeBigCode方法
    bigCode: "changeBigCode",
  },
  methods: {
    /** 初始 */
    initData() {
      this.userID = this.$store.state.userInfo.id;
      this.userName = this.$store.state.userInfo.name;
      this.bigCode = "";
      this.midCode = "";
      this.midName = "";
      this.memo = "";
    },
    /** 當十大類保障切換時變更中分類代碼 */
    async changeBigCode() {
      if (this.bigCode) {
        await queryMidCategoryMaxNum(this.userID, this.bigCode).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              const tempCode = result.data[0].code;
              const firstCode = tempCode.substring(0, 1);
              const needCode = (parseInt(tempCode.substring(1)) + 1)
                .toString()
                .padStart(3, "0");
              this.midCode = firstCode + needCode;
            } else {
              this.midCode = "取號失敗";
            }
          }
        );
      } else {
        this.midCode = "";
      }
    },
    /** 新增保障群組中分類 */
    async doInsert() {
      if (!this.bigCode) {
        this.$toast.info({ title: "請選擇大類" });
        return;
      }
      if (!this.midName) {
        this.$toast.info({ title: "請輸入中分類名稱" });
        return;
      }
      // if (!this.memo) {
      //   this.$toast.info({ title: "請輸入備註" });
      //   return;
      // }
      if (
        !this.chekTextRegExp(this.midName)
        // ||!this.chekTextRegExp(this.memo)
      ) {
        this.$toast.info({ title: "請勿輸入特殊字元" });
        return;
      }
      if (!confirm("確認要新增保障群組?")) {
        return;
      }
      this.reqData.code_category = this.bigCode;
      this.reqData.code = this.midCode;
      this.reqData.code_name = this.midName;
      this.reqData.creator = this.userID;
      this.reqData.creatorname = this.userName;
      // this.reqData.memo = this.memo;
      await insertMidCategory(this.userID, this.reqData).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增保障群組成功" });
          this.initData(); //清空資料
          this.$emit("reloadPage"); //重新讀取頁面
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    /** 關閉AddModal **/
    doClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
.editbtn {
  width: 120px;
  height: 40px;
}
</style>
